import initialState from './initialState'
import {
  FETCH_VIDEOS,
  FINISH_FETCH_VIDEOS,
  BEGIN_FETCH_VIDEOS,
} from '../actions/actionTypes'

export default function videosStuff(state = initialState.videos, action) {
  switch (action.type) {
    case BEGIN_FETCH_VIDEOS:
      return { ...state, isLoading: true }
    case FETCH_VIDEOS:
      return {
        ...state,
        videos: {
          ...state.videos,
          [action.folderName]: action.videos,
        },
      }
    case FINISH_FETCH_VIDEOS:
      return { ...state, isLoading: false }

    default:
      return state
  }
}
